export default "__VITE_ASSET__GeSFcdjL__"